import { onChangeMoveToContext } from '../actions/internalActions';
import MoveToMailboxContext from '../store/schema/MoveToMailboxContext';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';

// set moveToMailboxContext in store by subscribing to onViewAllMenuClicked action
mutator(onChangeMoveToContext, (actionMessage: { moveToMailboxContext: MoveToMailboxContext }) => {
    getStore().moveToMailboxContext = actionMessage.moveToMailboxContext;
});
